Auth = require 'db/auth'
LocalStorageModel = require 'view-models/internal/local-storage-model'
SimpleTest = require 'lib/experiments/simple-test'
_ = require 'underscore'

module.exports = class NotificationsSeenState extends LocalStorageModel
  # Model will be on instance of Member
  constructor: (@model) ->
    super()
    @set({ id: "NotificationsSeenState-#{ @model.id }" })
    @fetch()
    @enableTabSync()

  default: ->
    lastSeenNotificationGroup: {}

  setLastSeen: =>
    @update lastSeenNotificationGroup: @model.get('notificationsCount')

  getNewNotifications: (currentNotificationGroup) =>
    lastSeenNotificationGroup = @get 'lastSeenNotificationGroup'
    _.pick currentNotificationGroup, (count, key) ->
      count > (lastSeenNotificationGroup[key] ? 0)



// WEBPACK FOOTER //
// ./app/scripts/view-models/notifications-seen-state.coffee